import(/* webpackMode: "eager" */ "/usr/src/app/src/components/layouts/sidebar/sidebar.tsx");
